<div class="image-filters" (click)="$event.stopPropagation()">
  <div class="preset-filters">
    <div class="number-buttons">
      <button *ngFor="let num of [1, 2, 3]" mat-raised-button (click)="onPresetClick(num)"
        [color]="selectedPreset === num ? 'primary' : ''">
        {{ num }}
      </button>
    </div>
    <button mat-raised-button class="reset-button" color="primary" (click)="onResetFilters()">
      {{ 'button.reset' | translate }}
    </button>
  </div>
  <div *ngFor="let filter of getFilterToggle()" class="filter-item">
    <span class="filter-label">{{ 'image_filter.' + filter | translate }}</span>
    <div class="toggle-container">
      <mat-slide-toggle (change)="onToggleChange(filter, $event.checked)"
        [checked]="getFilterValue(filter) === 0 ? false : true"></mat-slide-toggle>
    </div>
  </div>
  <div *ngFor="let filter of getFilterSlider()" class="filter-item">
    <span class="filter-label">{{ 'image_filter.' + filter | translate }}</span>
    <mat-slider class="flex-grow-1" [min]="-100" [max]="100" [step]="5" (mousedown)="$event.stopPropagation()">
      <input matSliderThumb [value]="getFilterValue(filter)" (valueChange)="onSliderChange(filter, $event)" />
    </mat-slider>
    <span class="filter-value">{{ getFilterValue(filter) }}%</span>
  </div>
</div>
